import { ReactNode } from "react";
import Content from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Content/Content";
import TopRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRow/TopRow";
import TopRowMain from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRowMain/TopRowMain";
import BottomRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/BottomRow/BottomRow";
import Assigned from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Assigned/Assigned";
import TaskType from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TaskType/TaskType";
import Date from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Date/Date";
import Badges from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Badges/Badges";
import Indicators from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Indicators/Indicators";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

type CompletedTaskCardProps = {
  children: ReactNode;
  taskType: string | Loading;
  date: string | Loading;
  assigned: string | Loading;
  priority: boolean;
  safetyAlarm?: boolean;
  hasFile?: boolean;
  hasImage?: boolean;
  hasComment?: boolean;
};

function CompletedTaskCard({
  children,
  taskType,
  date,
  assigned,
  priority,
  safetyAlarm,
  hasFile,
  hasImage,
  hasComment,
}: CompletedTaskCardProps) {
  return (
    <Content>
      <TopRow>
        <TopRowMain>
          <TaskType value={taskType} />
          <Badges priority={priority} safetyAlarm={safetyAlarm} dim />
        </TopRowMain>
        <Indicators
          hasFile={hasFile}
          hasImage={hasImage}
          hasComment={hasComment}
        />
      </TopRow>
      {children}
      <BottomRow>
        <Assigned value={assigned} />
        <Date value={date} />
      </BottomRow>
    </Content>
  );
}

export default CompletedTaskCard;
